import * as React from "react";

const SvgIcon = ({ size = '64', color = '#f9a928' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 64 64"
  >
    <path
      fill={color}
      strokeWidth="1.032"
      d="M25.921 57.905H38.08C38.079 61.257 35.343 64 32 64s-6.079-2.743-6.079-6.095m33.434-6.095v3.047H4.645V51.81l6.079-6.096V27.43c0-9.448 6.079-17.677 15.197-20.42v-.914C25.921 2.743 28.657 0 32 0s6.079 2.743 6.079 6.095v.915c9.118 2.742 15.197 10.97 15.197 20.419v18.285ZM47.197 27.429c0-8.534-6.687-15.239-15.197-15.239S16.803 18.895 16.803 27.43v21.333h30.394Z"
    ></path>
  </svg>
);

export default SvgIcon;

